// extracted by mini-css-extract-plugin
module.exports = {"wound-card-list":"style_wound-card-list__MCrqP","wound-card-list-container":"style_wound-card-list-container__24v9b","width-align-center":"style_width-align-center__-PdB9"};